export const CLOSE_SCHOOL_YEAR_INITIALIZING = 'CLOSE_SCHOOL_YEAR_INITIALIZING';
export const CLOSE_SCHOOL_YEAR_SET_FISCAL_YEAR =
  'CLOSE_SCHOOL_YEAR_SET_FISCAL_YEAR';
export const CLOSE_SCHOOL_YEAR_SET_UNCLOSED_DATES =
  'CLOSE_SCHOOL_YEAR_SET_UNCLOSED_DATES';



// WEBPACK FOOTER //
// ./src/pages/CloseSchoolYear/state/types.js